<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style lang="scss" src="./assets/css/home/common.scss">



// WEBPACK FOOTER //
// src/App.vue